export default __webpack_public_path__ + "static/map/img/def_map.cb9aab5.png";